<template>
  <transition name="slide">
    <div v-if="isOpen" class="slidein">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "slideup-mobile",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      setIsFullscreen: "globals/setIsFullscreen"
    })
  },
  watch: {
    isOpen() {
      this.setIsFullscreen(this.isOpen);
      // this.setHasHeader(!this.isOpen);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.slide-enter,
.slide-leave-active {
  right: -100%;
}

.slidein {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  overflow-x: hidden;
  transition: all 0.5s ease-in-out;

  @media (min-width: $breakpoint-sm) {
    width: 22rem;
  }
}
</style>
